import { atom } from 'jotai';
import { User_Base } from '~/common/typescript/models/User';
import { UserLocation_Base } from '~/common/typescript/models/UserLocation';
import { AC_Project__User_with_Roles } from '~/common/typescript/services/access_control/AC_Project';
import { currentProjectAtom } from '~/stores/ProjectStore';
import { ProjectAPIs } from '~/common/typescript/apis/ProjectAPIs';

export const projectMembersLocationAtom = atom<UserLocation_Base[]>([]);

export const memberDisplayedBoundsAtom = atom<string | null>(null);

export const showMemberLabelsAtom = atom<boolean>(true); // Temporarily true for testing

// Base atom for project members with roles - shared across components
export const projectMembersWithRolesAtom = atom<AC_Project__User_with_Roles[]>([]);

// Map of project members indexed by user ID for instant O(1) lookup
export const projectMembersMapAtom = atom<Record<number, User_Base>>((get) => {
  const members = get(projectMembersWithRolesAtom);
  const map: Record<number, User_Base> = {};
  members.forEach((m) => {
    if (m?.user?.id) {
      map[m.user.id] = m.user;
    }
  });
  return map;
});

// Derived atom that automatically fetches members when project changes
export const projectMembersWithRolesAsyncAtom = atom(
  (get) => get(projectMembersWithRolesAtom),
  async (get, set) => {
    const currentProject = get(currentProjectAtom);
    if (!currentProject?.id) {
      set(projectMembersWithRolesAtom, []);
      return;
    }

    try {
      const membersWithRoles = await ProjectAPIs.remote_getUsers_with_Roles({
        projectId: currentProject.id,
      });
      set(projectMembersWithRolesAtom, membersWithRoles);
    } catch (error) {
      console.error('Error fetching project members:', error);
      set(projectMembersWithRolesAtom, []);
    }
  }
);